import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private versionSubject = new BehaviorSubject<string>(null);
  // Emits true when the running bundle itself is stale (service-worker update available).
  // Desktop registers no service worker today, so nothing pushes to it yet; the topbar
  // merges both streams so the mobile/PWA path can drive the same banner.
  private interfaceSubject = new BehaviorSubject<any>(null);

  versionStatus$ = this.versionSubject.asObservable();
  interfaceStatus$ = this.interfaceSubject.asObservable();

  setVersionStatus(newVersion: string) {
    this.versionSubject.next(newVersion);
  }

  setInterfaceStatus(newInterface: any) {
    this.interfaceSubject.next(newInterface);
  }

}
